import { createSlice } from "@reduxjs/toolkit";

const logSlice = createSlice({
    name: 'log',
    initialState: {
        logUsuario: []
    },
    reducers: {
        addLogusuario: (state, action) => {
            state.logUsuario = action.payload
        },
    }
})

export const { addLogusuario } = logSlice.actions;
export default logSlice.reducer;